import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { track } from "@/utils/ga";

export const SIZES = ["XS", "S", "M", "L", "XL", "XXL"];
export const COLORS = ["BLACK", "OFF WHITE"];

export const PRODUCT = {
  id: "shutup-tee",
  name: "THE SHUTUP T-SHIRT",
  price: 2000,
  colors: COLORS,
  fit: "OVERSIZED",
  edition: 200,
  thumb: "/images/campaign-2.webp",
};

export const inr = (n) => `₹${n.toLocaleString("en-IN")}`;

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("shutup-cart")) || [];
    } catch {
      return [];
    }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [rebelLine, setRebelLine] = useState("");

  useEffect(() => {
    localStorage.setItem("shutup-cart", JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    const lenis = window.__lenis;
    if (drawerOpen || checkoutOpen) lenis?.stop();
    else lenis?.start();
  }, [drawerOpen, checkoutOpen]);

  const add = (size, qty = 1, color = "BLACK") => {
    track("add_to_cart", {
      currency: "INR",
      value: PRODUCT.price * qty,
      items: [{ item_id: PRODUCT.id, item_name: PRODUCT.name, item_variant: `${color} / ${size}`, price: PRODUCT.price, quantity: qty }],
    });
    setItems((prev) => {
      const key = `${color}|${size}`;
      const found = prev.find((i) => i.key === key);
      return found
        ? prev.map((i) => (i.key === key ? { ...i, qty: i.qty + qty } : i))
        : [...prev, { key, color, size, qty }];
    });
  };

  const setQty = (key, qty) =>
    setItems((prev) =>
      qty <= 0 ? prev.filter((i) => i.key !== key) : prev.map((i) => (i.key === key ? { ...i, qty } : i))
    );

  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const value = useMemo(() => {
    const count = items.reduce((a, i) => a + i.qty, 0);
    return {
      items,
      count,
      total: count * PRODUCT.price,
      add,
      setQty,
      remove,
      clear,
      drawerOpen,
      setDrawerOpen,
      checkoutOpen,
      setCheckoutOpen,
      rebelLine,
      setRebelLine,
    };
  }, [items, drawerOpen, checkoutOpen, rebelLine]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}
